export default function isUndefined(value) {
    return value === undefined;
}
